import React from 'react';
import { Helmet } from 'react-helmet';

interface HeadProps {
  title: string;
  slug: string;
  description: string;
  ogImageUrl?: string;
}

const Head = ({ title, slug, description, ogImageUrl }: HeadProps): JSX.Element => (
  <Helmet>
    <title>{title}</title>
    <link rel="canonical" href={`https://wearerobyn.co${slug}`} />
    <meta name="description" content={description} />
    {/* OG */}
    <meta property="og:type" content="website" />
    <meta property="og:url" content={`https://wearerobyn.co${slug}`} />
    <meta property="og:description" content={description} />
    <meta property="og:title" content={title} />
    <meta property="og:image" content={ogImageUrl || `https://robyn-images.s3.amazonaws.com/preview-home-page.png`} />
    {/* Twitter */}
    <meta name="twitter:card" content="summary" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta
      name="twitter:image"
      content={ogImageUrl || 'https://robyn-images.s3.amazonaws.com/preview-home-page.png'}
    ></meta>
    ;{/* Hotjar Tracking Code for https://wearerobyn.co/ */}
    <script>
      {`
        (function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:2022544,hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `}
    </script>
  </Helmet>
);

export default Head;
